import { render, staticRenderFns } from "./widget-signature.vue?vue&type=template&id=e5fd58a2&scoped=true"
import script from "./widget-signature.vue?vue&type=script&lang=js"
export * from "./widget-signature.vue?vue&type=script&lang=js"
import style0 from "./widget-signature.vue?vue&type=style&index=0&id=e5fd58a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5fd58a2",
  null
  
)

export default component.exports